import React from 'react';
import PropTypes from 'prop-types';
/* Utils */
import { isCapOneProvider } from 'site-modules/shared/utils/financing/financing';
import { isPartnerDealer } from 'site-modules/shared/utils/dealer-details-utils';
/* Components */
import { CapitalOneEntryPointPrequalified } from './capital-one-entry-point-prequalified';
import { CapitalOneEntryPointPartner } from './capital-one-entry-point-partner';
import { CapitalOneEntryPointNonPartner } from './capital-one-entry-point-non-partner';

import './capital-one-entry-point.scss';

export function CapitalOneEntryPoint({
  vinData = {},
  isPrequalified = false,
  isFinancingError = false,
  financingOffer = {},
  isLoading = false,
  isCounterTriggered = false,
  isCapOneIneligible = false,
  shop4713Recipe = 'ctrl',
  isSimulatedLeadForm = false,
  isBol = false,
}) {
  const isCapOne = isCapOneProvider(vinData);
  const isPartner = isPartnerDealer(vinData);

  if (isPrequalified) {
    return (
      <CapitalOneEntryPointPrequalified
        isCapOne={isCapOne}
        isFinancingError={isFinancingError}
        financingOffer={financingOffer}
        isLoading={isLoading}
        isCounterTriggered={isCounterTriggered}
        vinData={vinData}
        isBol={isBol}
      />
    );
  }

  if (isPartner || isSimulatedLeadForm) {
    return (
      <CapitalOneEntryPointPartner
        vinData={vinData}
        isCapOne={isCapOne}
        isCapOneIneligible={isCapOneIneligible}
        shop4713Recipe={shop4713Recipe}
      />
    );
  }

  return (
    <CapitalOneEntryPointNonPartner vinData={vinData} isCapOne={isCapOne} isCapOneIneligible={isCapOneIneligible} />
  );
}

CapitalOneEntryPoint.propTypes = {
  vinData: PropTypes.shape({}),
  isPrequalified: PropTypes.bool,
  financingOffer: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.shape({})]),
  isFinancingError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isCounterTriggered: PropTypes.bool,
  isCapOneIneligible: PropTypes.bool,
  shop4713Recipe: PropTypes.string,
  isSimulatedLeadForm: PropTypes.bool,
  isBol: PropTypes.bool,
};
